import './index.scss'

import { useState } from 'react'
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom'

import PageTabs from '@components/PageTabs'
import { newServicePath } from './DetailsPage'
import SeriesEditorModal from './SeriesEditorModal'
import { RoutedSeries, seriesPagePath } from './SeriesPage'

const LIBRARY_PATH = '/services';
const SERIES_PATH = '/services/series';

// Services, split into tabs: All Services, and Series along with each
// series' services. The header stays up across all of them; only a service's
// own page leaves it, like a volunteer's does.
export default function ServicesPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const isLibrary = location.pathname === LIBRARY_PATH;
  const isSeriesList = location.pathname === SERIES_PATH;

  // Keyed per open, so each new series starts blank.
  const [isNewSeriesOpen, setIsNewSeriesOpen] = useState(false);
  const [newSeriesKey, setNewSeriesKey] = useState(0);

  let buttons;

  if (isLibrary) {
    buttons = [{
      label: 'New Service',
      icon: 'add' as const,
      // Starts at the campus and category All Services is showing.
      onClick: () => navigate(newServicePath(searchParams.get('campus'), searchParams.get('category')))
    }];
  } else if (isSeriesList) {
    buttons = [{
      label: 'New Series',
      icon: 'add' as const,
      onClick: () => {
        setNewSeriesKey((current) => current + 1);
        setIsNewSeriesOpen(true);
      }
    }];
  }

  return (
    <div className='services-layout'>
      <PageTabs
        title='Services'
        tabs={[
          { label: 'All Services', path: LIBRARY_PATH },
          { label: 'Series', path: SERIES_PATH }
        ]}
        buttons={buttons} />

      <SeriesEditorModal
        key={`new-series-${newSeriesKey}`}
        isOpen={isNewSeriesOpen}
        // Starts at the campus and category the Series tab is showing.
        initialCampusID={searchParams.get('campus')}
        initialCategoryID={searchParams.get('category')}
        close={() => setIsNewSeriesOpen(false)}
        onSaved={(created) => {
          setIsNewSeriesOpen(false);

          const state: RoutedSeries = { series: created };
          navigate(seriesPagePath(created), { state });
        }} />

      <Outlet />
    </div>
  )
}
